import * as types from "./enderecoPrincipal.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";

export default {
  setEnderecoPrincipal: data => ({
    type: types.ENDERECO_PRINCIPAL_SET,
    payload: data
  }),
  resetForm: () => ({
    type: commonActionType.RESET
  })
}

